// @flow
import auth from "./auth"
import users from "./users"

export default {
  auth,
  users
}
